import * as React from 'react';
import { useTrends } from '../hooks/use-trends';
import { useTopics } from '../hooks/use-topics';
import { useSubTopics } from '../hooks/use-sub-topics';
import { useVideos } from '../hooks/use-videos';
import { useEconomies } from '../hooks/use-economies';
import { useEvents } from '../hooks/use-events';
import { usePosts } from '../hooks/use-posts';
import { usePages } from '../hooks/use-pages';
import { usePeople } from '../hooks/use-people';
import { useOrganisations } from '../hooks/use-organisations';
import { useFeedEntries } from '../hooks/use-feed-entries';
import { useCitations } from '../hooks/use-citations';
import { useExpertiseLevels } from '../hooks/use-expertise-levels';
import { createInheritedProvider } from '../utils/create-inherited-provider';
export var defaultEntityDataHooks = {
  Trend: useTrends,
  Topic: useTopics,
  SubTopic: useSubTopics,
  Video: useVideos,
  Economy: useEconomies,
  Event: useEvents,
  Post: usePosts,
  Page: usePages,
  Person: usePeople,
  Organisation: useOrganisations,
  FeedEntry: useFeedEntries,
  Citation: useCitations,
  ExpertiseLevel: useExpertiseLevels
};
export var EntityDataHooksContext = React.createContext(defaultEntityDataHooks);
export var EntityDataHooksProvider = createInheritedProvider(EntityDataHooksContext);